import { render, staticRenderFns } from "./WelcomeCarousel.vue?vue&type=template&id=19eeedf1&scoped=true&"
import script from "./WelcomeCarousel.vue?vue&type=script&lang=js&"
export * from "./WelcomeCarousel.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeCarousel.vue?vue&type=style&index=0&id=19eeedf1&lang=less&scoped=true&"
import style1 from "./WelcomeCarousel.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19eeedf1",
  null
  
)

export default component.exports